<template>
  <div class="cooperation-page__toasts">
    <template v-if="stage.step === 4">
      <BaseAlert
        v-if="isEmployer"
        class="_success"
        :value="$tCooperation('toast.accepted.1')"
      />

      <BaseAlert
        v-else
        class="_success"
        :value="$tCooperation('toast.accepted.2')"
      />
    </template>

    <template v-if="(stage.interaction_model).declined === 1">
      <BaseAlert
        v-if="isEmployer"
        class="_error"
        :value="$tCooperation('toast.declined.1')"
      />

      <BaseAlert
        v-else
        class="_error"
        :value="$tCooperation('toast.declined.2')"
      />
    </template>
  </div>
</template>

<script>
  export default {
    props: [ 'stage', 'isAgent', 'isJobSeeker', 'isEmployer' ]
  };
</script>
